import * as THREE from 'three'
import store from '../store'

import Experience from './Experience'

import { breakpoints } from '../utils/breakpoints'

export default class Camera {
  constructor() {
    this.experience = new Experience()
    this.sizes = this.experience.sizes
    this.canvas = this.experience.canvas

    this.setInstance()
  }

  setInstance() {
    this.instance = new THREE.PerspectiveCamera(
      35,
      store.bounds.ww / store.bounds.wh,
      0.1,
      100,
    )

    if (store.sniffer.isDevice || store.bounds < breakpoints.MEDIUM) {
      this.instance.position.set(0, 0, 12)
    } else {
      this.instance.position.set(0, 0, 6)
    }

    store.camera = this.instance // to animate later w/ scroll trigger
  }

  resize() {
    this.instance.aspect = store.bounds.ww / store.bounds.wh
    this.instance.updateProjectionMatrix()
  }
}